import React from 'react'
import { nanoid } from 'nanoid'

import Loader from '../../../app/custom/loaders/Loader'
import LandlordFooter from '../../landlordModule/LandlordFooter'
import SchedulerHeader from './SchedulerHeader'
import ScheduleFilters from './filters/ScheduleFilters'
import ScheduleFiltersList from './filters/ScheduleFiltersList'
import ViewingsList from './viewingsList/ViewingsList'
import OffersList from './offersList/OffersList'
import ReferralsList from './referalsList/ReferralsList'
import AdvertiseList from './advertisesList/AdvertiseList'
import ScheduleViewingAttention from './attenton/ScheduleViewingAttention'
import ScheduleOfferAttention from './attenton/ScheduleOfferAttention'
import ScheduleAdvertiseAttention from './attenton/ScheduleAdvertiseAttention'
import { advertiseAttention, offersAttention, placeholders, viewingsAttention } from '../../../urls'
import { getDynamicHeight } from '../../../functions/utils/getDynamicHeight'
import { ScheduleAccordion } from './ScheduleAccordion'
import { type ScheduleViewModel } from './hooks/useScheduleVM'
import PortalRequestCard from './portalRequests/PortalRequestCard'
import AgentActivityList from './agentActivity/AgentActivityList'

interface ScheduleMobileViewProps {
    vm: ScheduleViewModel
}

export function ScheduleMobileView({ vm }: ScheduleMobileViewProps): JSX.Element {
    const {
        loading,
        filterNavigate,
        isThereNotices,
        expanded,
        setExpanded,
        advertisesNotifies,
        offersNotifies,
        viewingsNotifies,
        filteredAdvertises,
        filteredOffers,
        filteredViewings,
        allAttention,
        portalViewingRequests,
        portalOfferRequests,
        portalAllRequests,
        agentActivityCards,
        userDevice,
        isWithSidebar,
        filtersBottomOffset,
        mainButtonOpen,
        showPopupScheduleFilters,
        scheduleFiltersApply,
        setScheduleFiltersApply,
        openAgentActivityItem,
        openFiltersPopup,
        isDesktop
    } = vm

    if (loading) return <Loader />

    return (
        <>
            <div className="page d-flex flex-column flex-row-fluid h-100 schedule-page" id="header_scheduler"
                style={{ minHeight: `${getDynamicHeight()}px` }}
            >
                <SchedulerHeader
                    allAttention={allAttention.length}
                    countView={filteredViewings.length}
                    countOffers={filteredOffers.length}
                    advertisesCount={filteredAdvertises.length}
                    broadcastMessagesCount={0}
                    viewingsNotifies={viewingsNotifies?.length}
                    offersNotifies={offersNotifies?.length}
                    advertisesNotifies={advertisesNotifies?.length}
                    portalRequestsCount={portalAllRequests.length}
                    portalRequestsNotifies={portalAllRequests.length}
                    agentActivityCount={agentActivityCards.length}
                    isDesktop={isDesktop}
                />
                {userDevice === 'IPhone'
                    ? <div className="h-25px"></div>
                    : <></>
                }
                <div
                    className="m-0"
                    style={{
                        height: filterNavigate === 'attention'
                            ? '128px'
                            : '124px'
                    }}
                >
                </div >
                <div
                    className={'content d-flex flex-column flex-fill p-0 '}
                    id="calendar_tasks_list"
                >
                    <div className="schedule-page__inner px-4 my-2">
                        {/* <ScheduleLandlordPMCAttentionCard pendingTasksCount={allAttention.length} /> */}
                        {filterNavigate === 'attention'
                            ? (
                                isThereNotices
                                    ? <>
                                        {
                                            <ScheduleAccordion key={'Advertises'} group={'Advertises'} expanded={expanded}
                                                setExpanded={setExpanded} countLable={advertisesNotifies.length} imgCover={advertiseAttention} >
                                                {advertisesNotifies
                                                    .map((adv: any) => (
                                                        <div
                                                            key={adv.id}
                                                            className="card shadow-sm mb-4 position-relative"
                                                        >
                                                            <ScheduleAdvertiseAttention
                                                                key={"list-attention-advertises"}
                                                                advertise={adv}
                                                            />
                                                        </div>
                                                    ))}
                                            </ScheduleAccordion>
                                        }

                                        {
                                            <ScheduleAccordion key={'Offers'} imgCover={offersAttention} group={'Offers'} expanded={expanded} setExpanded={setExpanded} countLable={offersNotifies.length}>
                                                {offersNotifies
                                                    .map((offer: any) => (
                                                        <div
                                                            key={offer.id}
                                                            className="card shadow-sm mb-2 position-relative"
                                                        >
                                                            <ScheduleOfferAttention key={"list-attention-offers"} offer={offer} />
                                                        </div>
                                                    ))}
                                            </ScheduleAccordion>
                                        }
                                        {
                                            <ScheduleAccordion key={'Viewings'} imgCover={viewingsAttention} group={'Viewings'} expanded={expanded} setExpanded={setExpanded} countLable={viewingsNotifies.length}>
                                                {viewingsNotifies.length > 0 && viewingsNotifies.map((view: any) => (
                                                    <div key={view.id} className="card shadow-sm mb-2 mt-1 position-relative">
                                                        <ScheduleViewingAttention key={"list-attention-viewings"} view={view} />
                                                    </div>
                                                ))}
                                            </ScheduleAccordion>}
                                    </>
                                    :
                                    <div className={'d-flex position-relative align-items-end'} >
                                        <img
                                            className="w-75 object-fit-cover m-auto rounded rounded-4  opacity-100 mt-8"
                                            src={placeholders.Notices}
                                            alt={'liable_picture'}
                                        />
                                        <span className="fs-2x fs-lg-2 fw-bold text-white text-uppercase position-absolute text-center" style={{ bottom: '14%', left: '50%', transform: 'translateX(-50%)', textShadow: '1px 1px 10px #332d2dd9' }}>
                                            You don't have any new notifications
                                        </span>
                                    </div>
                            )
                            : null
                        }

                        {
                            filterNavigate === 'viewings'
                                ? (
                                    <>
                                        <ViewingsList viewings={filteredViewings} key={"list-viewings"} />
                                    </>
                                )
                                : null
                        }
                        {
                            filterNavigate === 'offers'
                                ? (
                                    <>
                                        <OffersList offers={filteredOffers} key={"list-offers"} />
                                    </>
                                )
                                : null
                        }
                        {
                            filterNavigate === 'agent_activity'
                                ? (
                                    <AgentActivityList cards={agentActivityCards} onTaskClick={openAgentActivityItem} compact />
                                )
                                : null
                        }
                        {
                            filterNavigate === 'portal_requests'
                                ? (
                                    portalAllRequests.length > 0
                                        ? <>
                                            <ScheduleAccordion key={'PortalViewingRequests'} group={'Viewing Requests'} expanded={expanded} setExpanded={setExpanded} countLable={portalViewingRequests.length} imgCover={viewingsAttention}>
                                                {portalViewingRequests.map((request) => (
                                                    <PortalRequestCard key={`portal-viewing-${request.orderId}`} request={request} />
                                                ))}
                                            </ScheduleAccordion>
                                            <ScheduleAccordion key={'PortalOfferRequests'} group={'Offer Requests'} expanded={expanded} setExpanded={setExpanded} countLable={portalOfferRequests.length} imgCover={offersAttention}>
                                                {portalOfferRequests.map((request) => (
                                                    <PortalRequestCard key={`portal-offer-${request.orderId}`} request={request} />
                                                ))}
                                            </ScheduleAccordion>
                                        </>
                                        : <div className={'d-flex position-relative align-items-end'} >
                                            <img
                                                className="w-75 object-fit-cover m-auto rounded rounded-4 opacity-100 mt-8"
                                                src={placeholders.Notices}
                                                alt={'liable_picture'}
                                            />
                                            <span className="fs-2x fs-lg-2 fw-bold text-white text-uppercase position-absolute text-center" style={{ bottom: '14%', left: '50%', transform: 'translateX(-50%)', textShadow: '1px 1px 10px #332d2dd9' }}>
                                                No portal requests yet
                                            </span>
                                        </div>
                                )
                                : null
                        }
                        {
                            filterNavigate === 'referrals'
                                ? (
                                    <ReferralsList key={"list-referrals"} />
                                )
                                : null
                        }
                        {
                            filterNavigate === 'adverts'
                                ? (
                                    <AdvertiseList advertises={filteredAdvertises} key={"list-adverts"} />
                                )
                                : null
                        }

                        {/* {
                        filterNavigate === 'broadcasts'
                            ? <BroadcastList broadcastMessages={broadcastMessages} key={"list-broadcasts"} />
                            : null
                    } */}
                    </div>
                </div >

                <div
                    className="m-0"
                    style={{ height: `${'190px'}` }}
                />

                <div
                    className={`schedule-filters-bar ${isWithSidebar ? 'schedule-filters-fab' : ''} px-4 py-2 bg-white`}
                    style={{
                        bottom: filtersBottomOffset
                    }}>
                    <div className={`btn btn-bso fs-5 w-auto py-4 d-flex align-items-center justify-content-center ls-1 ${isWithSidebar ? 'schedule-filters-fab__button' : ''}`}
                        onClick={openFiltersPopup}>
                        <i className="ki-duotone ki-setting-3 fs-2x m-n2 pe-2 ">
                            <span className="path1 "></span>
                            <span className="path2 "></span>
                            <span className="path3 "></span>
                            <span className="path4 "></span>
                            <span className="path5 "></span>
                        </i>Filters
                    </div >
                </div >

                <div className="position-relative">
                    {
                        !isWithSidebar && !mainButtonOpen
                            ? <LandlordFooter />
                            : null
                    }
                </div>
                <div className="d-none pb-14"></div>
            </div >
            {
                showPopupScheduleFilters ? (
                    <ScheduleFilters title='ScheduleFilters'>
                        <ScheduleFiltersList
                            key={nanoid()}
                            scheduleFiltersApply={scheduleFiltersApply}
                            setScheduleFiltersApply={setScheduleFiltersApply}
                            filteredViewings={filteredViewings}
                            filteredOffers={filteredOffers}
                            filteredAdvertises={filteredAdvertises}
                        />
                    </ScheduleFilters>
                ) : null}

        </>
    )
}
